// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1T2G2","content":"styles_content__1XUUa"};